
import { RallyRound } from '@/lib/models/RallyRound'
import { Component, Vue } from 'vue-property-decorator'
import BacInput from '../BacInput.vue'
import BacButton from '../BacButton.vue'
import UIkit from 'uikit'

@Component({
  components: {
    BacInput,
    BacButton
  }
})
export default class RallyRoundLiveSettings extends Vue {
  get rallyRound (): RallyRound {
    return this.$store.state.PageURLRallyRound.rallyRound
  }

  async saveRallyRound () {
    const success = await this.rallyRound.update()
    UIkit.notification({
      message: success ? 'Daten gespeichert!' : 'Fehler beim Speichern aufgetreten!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}
